import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReset } from '../actions/fetch.actions';
import { fetchForTable } from '../actions/table.actions';
import { fetchingSelector, shouldFetchSelector, fetchErrorSelector } from '../selectors/fetch.selectors';
import { tableDataSelector } from '../selectors/resources.selectors';

export const useTableResource = (resource, preferences = {}, errorHandlers) => {
  const dispatch = useDispatch();
  const shouldFetch = useSelector((state) => shouldFetchSelector(state, { resource }));
  const isLoading = useSelector((state) => fetchingSelector(state, { resource }));
  const { data, config } = useSelector((state) => tableDataSelector(state, { resource }));
  const error = useSelector((state) => fetchErrorSelector(state, { resource }));
  const { isFetched, sort, size } = preferences;

  const onReset = () => {
    dispatch(fetchReset(resource));
  };

  useEffect(() => {
    isFetched && shouldFetch && dispatch(fetchForTable(resource, { sort, size, errorHandlers }));
  }, [shouldFetch, isFetched, dispatch, errorHandlers, sort, size, resource]);

  return { data, config, shouldFetch, isLoading, error, onReset };
};
